import React, { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";
import { requestWithToken } from "../utils/apis";
import moment from "moment";
import { helpPagesData } from "../utils/helper";
import { Spinner } from "react-bootstrap";
import Help from "../components/Help";
import trash from "../assets/trash.svg";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import Paginate from "../components/pagination";
import DeleteModal from "../components/DeleteModal";
import { toast } from "react-toastify";

const Blogs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const confirmDelete = async () => {
    if (!fileToDelete) return;
    setDeleteLoader(true);
    await handleDelete(fileToDelete);
    setFileToDelete(null);
    setDeleteLoader(false);
    setShowDeleteModal(false);
  };
  const [blogData, setBlogData] = useState({
    loading: false,
    data: [],
  });
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
  });
  const fetchBlogs = async () => {
    setBlogData({ ...blogData, loading: true });
    try {
      const result = await requestWithToken(
        "GET",
        `/api/blogs/list?page=${pagination.page}&limit=${pagination.limit}&type=1&is_published=`
      );
      if (result?.status === 200) {
        setPagination((prev) => ({
          ...prev,
          total: Math.ceil(result.data.data.total / prev.limit) || 0,
        }));
        setBlogData({ data: result?.data?.data?.list || [], loading: false });
      }
    } catch (error) {
      setBlogData({ data: [], loading: false });
    }
  };
  useEffect(() => {
    fetchBlogs();
  }, [params]);

  const handleDelete = async (id) => {
    try {
      const result = await requestWithToken("DELETE", `/api/blogs/${id}`);
      if (result?.status === 200) {
        setBlogData((prev) => ({
          ...prev,
          data: prev.data.filter((item) => item._id !== id),
        }));
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong. Please try again."
      );
      console.error(error);
    }
  };

  const handlePageChange = (page) => {
    const newParams = new URLSearchParams(location.search);
    newParams.set("page", page);
    newParams.set("limit", pagination.limit);

    navigate(`?${newParams.toString()}`, { replace: true });

    setPagination((prev) => ({ ...prev, page: page }));
  };

  const handlePageSizeChange = (limit) => {
    const newParams = new URLSearchParams(location.search);
    newParams.set("page", 1);
    newParams.set("limit", limit);

    navigate(`?${newParams.toString()}`, { replace: true });

    setPagination((prev) => ({ ...prev, limit: limit, page: 1 }));
  };

  const { loading, data = [] } = blogData;
  return (
    <>
      <PageHeader pageTitle="Blogs">
  
          <Help
            title={helpPagesData.pages.title}
            message={helpPagesData.pages.message}
            items={helpPagesData.pages.items}
          />
          <NavLink to="/blogs/add-blogs" className="btn-black">
            Create New
          </NavLink>
 
      </PageHeader>
      <div className="page-container">
        <div className="theme-card p-4">
          <div className="card-title pb-3">Overview</div>
          <div className="table-responsive">
            <table className="pages-table">
              <thead>
                <tr>
                  <th>Blog Title</th>
                  <th>Slug</th>
                  <th>Status</th>
                  <th>Date Published</th>
                  <th style={{ textAlign: "center" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      <Spinner size="md" />
                    </td>
                  </tr>
                ) : data?.length === 0 ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      No data found.
                    </td>
                  </tr>
                ) : (
                  data.map((form, index) => (
                    <tr
                      key={index}
                      onClick={() => navigate(`/blogs/${form._id}`)}
                      style={{ cursor: "pointer" }}
                    >
                      <td>{form.title || "-"}</td>
                      <td>{form.slug || "-"}</td>
                      <td>
                        {form?.is_published ? (
                          <span className="status success">Published</span>
                        ) : (
                          <span className="status danger">Draft</span>
                        )}
                      </td>
                      <td>
                        {form?.is_published
                          ? moment(form.publish_date).format(
                              "DD/MM/YYYY"
                            )
                          : "-"}
                      </td>

                      <td style={{ textAlign: "center" }}>
                        <button
                          className="delete-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            setFileToDelete(form._id);
                            setShowDeleteModal(true);
                          }}
                        >
                          <img src={trash} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            <div className="px-3 pb-3">
              {Boolean(pagination?.total) && (
                <Paginate
                  currentPage={pagination?.page}
                  totalPages={pagination?.total}
                  onPageChange={handlePageChange}
                  pageSize={pagination.limit}
                  onPageSizeChange={handlePageSizeChange}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onDelete={confirmDelete}
        deleting={deleteLoader}
      />
    </>
  );
};

export default Blogs;
